import { useQuery } from "@tanstack/react-query";
import adminApiClient, { MenuNavigationDistributionResponse } from "api/admin";

export type MenuNavigationRange =
  | { days: number }
  | { from: string; to: string };

export default function useMenuNavigationDistribution(
  range: MenuNavigationRange,
) {
  return useQuery<MenuNavigationDistributionResponse>({
    queryKey: ["menuNavigationDistribution", range],
    queryFn: () => adminApiClient.getMenuNavigationDistribution(range),
  });
}
